import { SntSelectWidget, usePagedSelectOptions, type SntSelectOption } from "@cleanup/widgets/selectors/SntSelect";

interface SntLazyLoadSelectWidgetProps {
  /** Value of the selected option. */
  value: number;
  onChange?: (value: SntSelectOption<number> | null) => void;
  items: readonly SntSelectOption<number>[];
  placeholder?: string;
}

/**
 * Picker for a long, caller-supplied list: the menu holds a page of the options
 * matching the typed text, and more as it is scrolled (see usePagedSelectOptions).
 */
const SntLazyLoadSelectWidget = ({ value, onChange, items, placeholder }: SntLazyLoadSelectWidgetProps) => {
  const paged = usePagedSelectOptions(items);

  return (
    <SntSelectWidget
      options={paged.options}
      value={items.find((item) => item.value === value) ?? null}
      onChange={(selected) => onChange?.(selected)}
      placeholder={placeholder}
      filterOption={paged.filterOption}
      onInputChange={paged.onInputChange}
      onMenuScrollToBottom={paged.onMenuScrollToBottom}
      minHeight={34}
      menuPlacement="auto"
    />
  );
};

export default SntLazyLoadSelectWidget;
